<template>
  <!--  -->
  <div id="HomePage">
    <!-- 轮播图 -->
    <div class="block" :style="{ height: carouselHeigit }">
      <el-carousel class="carousel" height="carouselHeigit" indicator-position="none">
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <el-image class="elImage" :style="{ height: carouselHeigit }" :src="item.img"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 服务 -->
    <div class="service">
      <div class="service-content">
        <div class="service-title">
          <span>服务</span>
        </div>
        <div class="service-item">
          <div class="service-left">
            <div class="service-top">共享制造</div>
            <div class="service-bottom">扎根产业集群，提供优质生产服务</div>
          </div>
          <div class="service-right">
            <div class="service-right-video-wrap">
              <img class="service-swiper-video" src="../assets/img/jx/shareMake.jpg" alt="共享制造" />
              <!-- <video muted preload data-object-fit="true" class="service-swiper-video"
                poster="../assets/img/jx/no-video1.png"
                src="https://juxiangshare.com/data-center/jx-video/jx/service/video1.mp4" autoplay
                loop></video> -->
            </div>
          </div>
        </div>

        <div class="service-item">
          <div class="service-left">
            <div class="service-top">整单速产</div>
            <div class="service-bottom">汇集品牌工厂，会员独享服务</div>
          </div>
          <div class="service-right">
            <div class="service-right-video-wrap">
              <img class="service-swiper-video" src="../assets/img/jx/fastProduct.jpg" alt="整单速产" />
              <!-- <video muted preload data-object-fit="true" class="service-swiper-video"
                poster="../assets/img/jx/no-video1.png"
                src="https://juxiangshare.com/data-center/jx-video/jx/service/video2.mp4" autoplay
                loop></video> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 动态 -->
    <div class="news">
      <div class="news-content">
        <div class="title">
          <span>动态</span>
          <span class="more" @click="more()">
            更多
            <img src="@/assets/img/left_more.png" alt="" @click="more()" />
          </span>
        </div>
        <div class="news-wrap">
          <div class="news-wrap-item" v-for="(item, index) in newsList" :key="index" @click="goDetail(item)">
            <div class="news-wrap-item-top">
              <img :src="item.dynamicImageUrl" />
            </div>
            <div class="news-wrap-item-bottom">
              <div class="news-wrap-item-bottom-title">
                {{ item.dynamicTitle }}
              </div>
              <div class="news-wrap-item-bottom-des">
                {{ getSimpleText(item.dynamicContent) }}
              </div>
              <div class="news-wrap-item-bottom-time">
                <img src="@/assets/img/clock.png" />
                <span>{{
                  item.createTime ? item.createTime.slice(0, 11) : ""
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Swiper from "swiper";
// import { WOW } from "wowjs";
import API from "../api/index";
export default {
  name: "HomePage",
  components: {},
  data() {
    return {
      carouselHeigit: "900px",
      // loading: false,
      newsList: [],
      swiperList: [
        {
          img: require("@/assets/img/banner/banner/banner0.jpg"),
        },
        {
          img: require("@/assets/img/banner/banner/banner3.jpg"),
        },
        {
          img: require("@/assets/img/banner/banner/banner4.jpg"),
        },
        {
          img: require("@/assets/img/banner/banner/banner2.jpg"),
        },
        {
          img: require("@/assets/img/banner/banner/banner1.jpg"),
        },
      ],
    };
  },
  mounted() {
    // this.loading = true;
    let that = this;
    that.$nextTick(() => {
      that.getSwiperHeight();
    });
    window.onresize = function () {
      that.getSwiperHeight();
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    getSwiperHeight() {
      let docWidth = document.body.clientWidth;
      this.carouselHeigit = docWidth * 0.417 + "px";
      console.log(this.carouselHeigit, "this.carouselHeigit");
    },
    more() {
      this.$router.push("/newsMore");
    },
    goDetail(item) {
      this.$router.push(`/newsDetail/${item.pkid}`);
    },
    // 获取动态
    getNewsList() {
      let params = {
        pageNum: 1,
        pageSize: 9999,
      };
      API.news.getNews(params).then((res) => {
        if (res.code == 200) {
          res.rows = res.rows.filter((item) => {
            return item.status == 0;
          });
          res.rows = res.rows.filter((item) => {
            return item.homeShowStatus == 0;
          });
          if (res.rows.length > 3) {
            this.newsList = res.rows.slice(0, 3);
          } else {
            this.newsList = res.rows;
          }
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    getSimpleText(html) {
      var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, ""); //执行替换成空字符
      return msg;
    },
  },
};

</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
  /* padding-top: 97px; */
}

.block {
  width: 100%;
  /* margin-top: 100px; */
}

.carousel {
  width: 100%;
  height: 100%;
}

.el-carousel__item {
  width: 100%;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}

.elImage {
  width: 100%;
}

.service {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.service-content {
  /* width: 64%; */
  width: 1200px;
}

.service-content .service-title {
  margin-top: 20px;
  font-size: 40px;
  color: #333333;
}

.service-content .service-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
}

.service-content .service-item .service-left {
  flex: 1;
}

.service-content .service-item .service-left .service-top {
  font-size: 54px;
  color: #333333;
}

.service-content .service-item .service-left .service-bottom {
  font-size: 24px;
  color: #888888;
}

.service-content .service-item .service-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.service-right-video-wrap {
  border-radius: 20px;
  width: 652px;
  height: 489px;
  overflow: hidden;
  border-radius: 16px;
}

.service-right-video-wrap video {
  width: 100%;
  height: 100%;
}

.service-content .service-item .service-right .service-swiper-video {
  width: 100%;
  height: 100%;
  object-fit: fill;
  /* object-fit: cover; */
}

.service-content .service-item .service-right .vjs-control-bar {
  display: none !important;
}

.service-content .service-item .service-right img {
  width: 652px;
  height: 489px;
  border-radius: 16px;
}

.news {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-content {
  /* width: 64%; */
  width: 1200px;
}

.news-content .title {
  margin-top: 20px;
  font-size: 40px;
  color: #333333;
  display: flex;
  justify-content: space-between;
}

.news-content .more {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #888888;
  cursor: pointer;
}

.news-content .more img {
  margin-left: 10px;
  width: 11px;
  height: 15px;
  cursor: pointer;
}

.news-wrap {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  margin-top: 20px;
  margin-bottom: 100px;
}

.news-wrap::after {
  content: " ";
  height: 0;
  width: 380px;
  display: block;
}

.news-wrap-item {
  width: 380px;
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 1px 12px 0px rgba(102, 102, 102, 0.1);
  border-radius: 16px;
  transition: width 0.5s, height 0.5s, transform 0.5s;
  cursor: pointer;
}

.news-wrap-item:hover {
  /* transform: scale(1.1); */
}

.news-wrap-item-top {
  width: 100%;
  height: 64%;
}

.news-wrap-item-top img {
  width: 100%;
  height: 100%;
  border-radius: 16px 16px 0 0;
  /* transition: width 2s, height 2s, transform 2s; */
}

.news-wrap-item-top img:hover {
  /* transform: rotate(360deg); */
}

.news-wrap-item-bottom {
  padding: 24px 24px 0 24px;
}

.news-wrap-item-bottom-title {
  font-size: 20px;
  color: #333333;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-wrap-item-bottom-des {
  margin-top: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #777e87;
}

.news-wrap-item-bottom-time {
  margin-top: 13px;
  display: flex;
}

.news-wrap-item-bottom-time img {
  width: 16px;
  height: 16px;
}

.news-wrap-item-bottom-time span {
  margin-left: 10px;
  color: #afb6be;
  font-size: 12px;
}

.swiper .vjs-big-play-button {
  display: none;
}

.swiper .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: none;
}

/* 媒体查询（平板） */
@media screen and (min-width: 1600px) and (max-width: 1720px) {
  /* .news-wrap-item {
    width: 300px;
  } */
}

/* 媒体查询（平板） */
@media screen and (min-width: 1400px) and (max-width: 1600px) {
  /* .news-wrap-item {
    width: 250px;
  } */
}

@media screen and (min-width: 0) and (max-width: 1400px) {
  /* .news-wrap-item {
    width: 200px;
  } */
}

@media screen and (min-width: 0) and (max-width: 1300px) {
  /* .news-wrap-item {
    width: 200px;
  } */
}

@media screen and (min-width: 0) and (max-width: 1200px) {
  .swiper-wrapper {
    width: 100%;
    height: 50vh;
    /* height: 760px; */
    /* height: 800px; */
  }

  .service-content .service-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-bottom: 50px;
  }

  .service-content .service-item .service-left .service-top {
    font-size: 54px;
    color: #333333;
    display: flex;
    justify-content: center;
  }

  .service-right {
    margin-top: 20px;
  }

  #swiper .banner-swiper .swiper-slide-title {
    z-index: 999999999;
    width: 100%;
    height: 100%;
    color: #fff;
    text-align: left;
    line-height: 40px;
    padding: 0 10px;
  }

  #swiper .banner-swiper .swiper-slide-title .header_title {
    font-size: 25px;
    margin-top: 80px;
  }

  #swiper .banner-swiper .swiper-slide-title .header_content {
    font-size: 16px;
    color: #cccccc;
    /* margin-top: 1%; */
  }

  .news-content {
    /* width: 64%; */
    width: 100%;
    padding: 0 10px;
  }

  .service-content {
    /* width: 64%; */
    width: 100%;
    padding: 0 10px;
  }

  .news-wrap-item {
    width: 32%;
  }

  .service-content .service-title {
    margin-top: 20px;
    font-size: 30px;
    color: #333333;
  }

  .service-content .service-item .service-left .service-top {
    font-size: 27px;
    color: #333333;
  }

  .service-content .service-item .service-left .service-bottom {
    font-size: 22px;
    color: #888888;
  }

  .service-right-video-wrap {
    width: 100%;
    height: 100%;
  }

  .news-wrap-item {
    width: 380px;
    margin-top: 50px;
  }
}

@-webkit-keyframes anLoca {
  from {
    -webkit-transform: scale3d(1.2, 1.2, 1.2);
  }

  to {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
  }
}

.swiper-button-prev {
  left: 2px;
}

.swiper-button-next {
  right: 2px;
  color: #ffffff;
}

.btn_sty_left {
  color: #ffffff;
  background-image: url("../assets/img/left.png") !important;
  /* background-size:40px 50px; */
}

.btn_sty_right {
  color: #ffffff;
  background-image: url("../assets/img/right.png") !important;
  /* background-size:40px 50px; */
}

.btn_sty_left_color {
  color: #ffffff;
  background-image: url("../assets/img/left_color.png") !important;
  /* background-size:50px 70px; */
}

.btn_sty_right_color {
  color: #ffffff;
  background-image: url("../assets/img/right_color.png") !important;
  /* background-size:50px 70px; */
}

.btn-info {
  background-color: #716af5 !important;
}

.btn-info:hover {
  background-color: #6858fd !important;
}

.img-responsive {
  margin-top: 40px;
  margin-left: 60px;
}

@media screen and (max-width:699px) {
  .news-wrap{
    display: flex;
    /* align-items: center; */
    justify-self: center;
    flex-direction: column;
  }
  .news-wrap-item{
    width:100%;
  }
  .block .carousel .el-carousel__indicators--horizontal{
    display: none;
  }
  .service-content .service-item .service-left .service-top {
    font-size: 28px;
    color: #333333;
    display: flex;
    justify-content: center;
  }
  .service-content .service-item .service-left .service-bottom {
    font-size: 18px;
    color: #888888;
  }
  .news-content .title {
    font-size: 32px;
    /* color: #888888; */
  }
}

@media screen and (min-width:700px) and (max-width:1200px) {
  .news-wrap {
    display: flex;
    align-items: center;
    justify-self: center;
    flex-direction: column;
  }

}
</style>
<style>
.el-loading-spinner .el-loading-text {
  color: #cccccc;
}

.el-loading-spinner i {
  color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue